var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDebit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 16.6667C9.54009 16.6667 9.16699 16.2936 9.16699 15.8334L9.16699 4.16671C9.16699 3.70647 9.54009 3.33338 10.0003 3.33338C10.4606 3.33338 10.8337 3.70647 10.8337 4.16671L10.8337 15.8334C10.8337 16.2936 10.4606 16.6667 10.0003 16.6667Z",
    fill: "#E76F51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5896 9.75596C15.2641 10.0814 14.7365 10.0814 14.4111 9.75596L10.0003 5.34522L5.58958 9.75596C5.26414 10.0814 4.73651 10.0814 4.41107 9.75596C4.08563 9.43053 4.08563 8.90289 4.41107 8.57745L9.41107 3.57745C9.73651 3.25201 10.2641 3.25201 10.5896 3.57745L15.5896 8.57745C15.915 8.90289 15.915 9.43053 15.5896 9.75596Z",
    fill: "#E76F51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebit);
export default __webpack_public_path__ + "static/media/debit.751020e6b6651459520b1ec91c79ea5f.svg";
export { ForwardRef as ReactComponent };